import {
  ADD_DATA_CUT_TO_RULE,
  CREATE_RULE,
  DELETE_RULE,
  DELETE_DATA_CUT_FROM_RULE,
  RULES_FETCH_SUCCESS,
  SET_SELECTED_RULE,
  UPDATE_DATA_CUT_TO_RULE,
  UPDATE_RULE,
  UPDATE_RULES,
  APPLY_RULE_TO_JOBS,
  SET_RULE_NAME,
  START_EDITING_RULE_NAME,
  SET_TEMP_RULE_NAME,
  CANCEL_RULE_NAME_EDITING,
  SAVE_RULE_NAME,
  SET_RULE_NAME_ERORR,
  UPDATE_AUDIT_INFO,
  VIEW_NOT_PRICED_JOBS,
  VIEW_PRICED_JOBS,
  CLEAR_SELECTED_RULE
} from './RulesActions';

const initialState = {
  rules: [],
  selectedRule: {},
  summaryData: null,
  isEditing: false,
  ruleName: '',
  tempName: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_SELECTED_RULE: {
      return {
        ...state,
        selectedRule: {},
        rules: []
      };
    }
    case UPDATE_AUDIT_INFO: {
      const newRules = state.rules.map(rule => {
        if (rule.id === action.data.id) {
          return {
            ...rule,
            lastModified: action.data.lastModified,
            lastModifiedBy: action.data.lastModifiedBy
          };
        }
        return rule;
      });

      return {
        ...state,
        selectedRule: {
          ...state.selectedRule,
          lastModified: action.data.lastModified,
          lastModifiedBy: action.data.lastModifiedBy
        },
        rules: newRules
      };
    }
    case ADD_DATA_CUT_TO_RULE:
      return {
        ...state,
        selectedRule: {
          ...state.selectedRule,
          dataCuts: state.selectedRule.dataCuts.concat({
            id: action.id,
            priority: action.priority,
            dataCut: action.dataCut
          })
        }
      };
    case CREATE_RULE:
      return {
        ...state,
        rules: [action.data, ...state.rules],
        selectedRule: action.data
      };
    case DELETE_RULE:
      return {
        ...state,
        rules: state.rules.filter(rule => rule.id !== action.data)
      };
    case DELETE_DATA_CUT_FROM_RULE:
      return {
        ...state,
        selectedRule: {
          ...state.selectedRule,
          dataCuts: state.selectedRule.dataCuts.filter(connection => {
            return connection.id !== action.data;
          })
        }
      };
    case RULES_FETCH_SUCCESS:
      return {
        ...state,
        rules: action.rules,
        ruleName: action.rules.length > 0 ? action.rules[0].name : state.ruleName
      };
    case SET_SELECTED_RULE:
      return {
        ...state,
        selectedRule: action.data,
        isEditing: false,
        ruleName: action.data.name
      };
    case UPDATE_DATA_CUT_TO_RULE: {
      const updatedDataCutConnection = state.selectedRule.dataCuts.map(connection => {
        if (connection.id === action.data.id) {
          return { ...connection, priority: action.data.priority };
        }
        return connection;
      });

      return {
        ...state,
        rules: state.rules.map(rule =>
          rule.id === state.selectedRule.id ? { ...rule, dataCutConnection: updatedDataCutConnection } : rule
        ),
        selectedRule: {
          ...state.selectedRule,
          dataCuts: updatedDataCutConnection
        }
      };
    }
    case UPDATE_RULE: {
      const updatedRules = state.rules.map(rule => {
        if (rule.id === action.data.id) {
          return {
            ...rule,
            name: action.data.name,
            lowerLimitCO: action.data.lowerLimitCO,
            lowerLimitEE: action.data.lowerLimitEE
          };
        }
        return rule;
      });

      return {
        ...state,
        rules: updatedRules,
        selectedRule: {
          ...state.selectedRule,
          name: action.data.name,
          lowerLimitCO: action.data.lowerLimitCO,
          lowerLimitEE: action.data.lowerLimitEE
        }
      };
    }
    case UPDATE_RULES:
      return {
        ...state,
        rules: action.data,
        selectedRule: action.data[0]
      };

    case SET_RULE_NAME:
      return {
        ...state,
        ruleName: action.ruleName
      };
    case START_EDITING_RULE_NAME:
      return {
        ...state,
        isEditing: true
      };
    case SET_TEMP_RULE_NAME:
      return {
        ...state,
        tempName: action.name
      };
    case SAVE_RULE_NAME: {
      const ruleName = action.name.length ? action.name : state.ruleName;

      return {
        ...state,
        isEditing: false,
        ruleName,
        tempName: ''
      };
    }
    case CANCEL_RULE_NAME_EDITING:
      return {
        ...state,
        isEditing: false,
        ruleName: state.ruleName,
        tempName: ''
      };
    case APPLY_RULE_TO_JOBS: {
      const selectedTab = action.data.priced && action.data.priced.length > 0 ? 'priced' : 'notPriced';
      const summaryData = {
        ...action.data,
        selectedTab
      };

      return {
        ...state,
        summaryData
      };
    }
    case VIEW_NOT_PRICED_JOBS:
      return {
        ...state,
        summaryData: {
          ...state.summaryData,
          selectedTab: 'notPriced'
        }
      };
    case VIEW_PRICED_JOBS:
      return {
        ...state,
        summaryData: {
          ...state.summaryData,
          selectedTab: 'priced'
        }
      };
    default:
      return { ...state };
  }
}

export const rulesActions = {};
